export const environment = {
  production: false,
  orgAppId: 6120,
  baseAPIUrl: 'https://kenindia-api.insure.digital/',
  authAPIURL: 'https://auth-api.insure.digital/',
  uatLoginCommonUrl: 'https://auth.insure.digital/',
  siteBaseUrl: 'https://kenindia.insure.digital/',
  jengapgwUrl: 'https://v3-uat.jengapgw.io/processPayment',
  ipifyUrl: 'https://api.ipify.org?format=json',
  tokenDecryptKey: 'KfPjZn7jPu6rtRyMZGzV81+wU4hKnYCr9eKw5Pn5H6Y=',
  uadLogin: 'https://auth-kenindia.insure.digital/',
};
